import React, { useMemo } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { AlertColor } from '@mui/material/Alert';
import { useFeatureFlag } from 'modules/common/hooks';
import { useEnabledGroupTypes } from './hooks/useEnabledGroupTypes';
import { useSmartSuggestionSetting } from './hooks/useSmartSuggestionSetting';
import { SmartSuggestionPage } from './SmartSuggestionPage';
import { StartEndSettingsPageSkeleton } from './StartEndSettingsPageSkeleton';

const useStyles = makeStyles(() => ({
  div: () => ({
    width: '100%'
  })
}));

type SmartSettingsLandingProps = {
  onClose?: () => void;
  setAlert?: React.Dispatch<React.SetStateAction<boolean>> | undefined;
  setSeverity?: React.Dispatch<React.SetStateAction<AlertColor>>;
};
export const SmartSuggestionLanding: React.FC<SmartSettingsLandingProps> = ({
  onClose,
  setAlert,
  setSeverity
}: SmartSettingsLandingProps) => {
  const {
    data: settingsData,
    loading: settingsLoading
  } = useSmartSuggestionSetting();
  const classes = useStyles();
  const isTiAutoAcceptUserSettingsEnabled = useFeatureFlag(
    'isTiAutoAcceptUserSettingsEnabled'
  );
  const { data, loading } = useEnabledGroupTypes();
  const enabledGroupTypes = useMemo(
    () => data?.enabledGroupTypes?.items || [],
    [data]
  );
  const settings = useMemo(
    () => settingsData?.getSmartSuggestionSettings.settings || [],
    [settingsData]
  );
  if (loading || settingsLoading) {
    return <StartEndSettingsPageSkeleton />;
  }

  return (
    <div
      data-testid="SmartSuggestionLanding"
      className={isTiAutoAcceptUserSettingsEnabled ? classes.div : undefined}
    >
      <SmartSuggestionPage
        enabledGroupTypes={enabledGroupTypes}
        settings={settings}
        onClose={onClose}
        setAlert={setAlert}
        setSeverity={setSeverity}
      />
    </div>
  );
};
